import { useEffect, useState } from "react";
import Loader from "../../../../components/Loader/Loader";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import AttributeTableRows from "./AttributeTableRows";
import axios from "axios";
import {
  ALREADY_EXIST,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../../common/Constant";
import config from "../../../../config/config";
import { toastError, toastSuccess } from "../../../../common/Toast";
import { Link, useHistory, useNavigate, useLocation } from "react-router-dom";
import { checkUserPermission } from "../../../../common/UserPermission";

// The below variable are for permission given to the Functionalities
let PERMISSION_ADD_EDIT = "add-edit-attributes";
let PERMISSION_DELETE = "delete-attributes";

const Attributes = () => {
  const [loading, setLoading] = useState(false);
  const [rowsData, setRowsData] = useState([
    { id: 0, name: "", values: "", IsShowEcommerce: 0 },
  ]);
  console.log(rowsData, "data444 last");
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");
  const [valueAllChecked, setValueAllChecked] = useState();
  const [checkedBox, setCheckedBox] = useState([]);
  const [showDateFilterModal, setShowDateFilterModal] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  let itemId = location.state;
  if (itemId === null) {
    itemId = 0;
  }
  console.log("location.state 25", itemId);

  const addTableRows = () => {
    const rowsInput = {
      id: 0,
      name: "",
      // values: "",
      IsShowEcommerce: 0,
    };

    setRowsData([...rowsData, rowsInput]);
  };

  const deleteTableRows = (attributeId) => {

    axios
    .post(
      `${config.attributesBaseUrl}/attributes/singleattributedelete`,
      {attributeId : attributeId, loginUserId: loginUserId},
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      }
    )
    .then((res) => {
      if (res.data.ResponseCode === "SUCCESS") {
        toastSuccess(res.data.ResponseMessage)
        // console.log("SetDone");
        attributefetchApi();
        setLoading(false);
      } else if (
        res.data.ResponseCode === "ERROR" &&
        res.data.ResponseID === -1
      ) {
        toastError(res.data.ResponseMessage);
        setLoading(false);
      } else {
        toastError(res.data.ResponseMessage);
        setLoading(false);
      }
    }).catch((error) => {
      console.log(error)
      setLoading(false);
    });

    // const rows = [...rowsData];
    // rows.splice(index, 1);
    // setRowsData(rows);
  };

  const handleChangeTableRow = (index, evnt) => {
    console.log(evnt.toString(), "data444 new");
    let id, name, values;
    if (evnt.target === undefined) {
      name = "values";
      values = evnt.toString();
    } else {
      name = evnt.target.name;
      values = evnt.target.value;
    }

    const rowsInput = [...rowsData];
    rowsInput[index][name] = values;
    console.log(rowsInput, "885");

    setRowsData(rowsInput);
  };

  let previousPage;

  const attributefetchApi = () => {
    axios
      .get(`${config.attributesBaseUrl}/attributes?itemid=${0}`, {
        // itemId
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        const responseData = response.data.ResponseData;

        setRowsData(responseData);

        const updatedData = responseData?.filter(
          (el) => el.IsShowEcommerce === 1
        );
        const idArray = updatedData.map((el) => el.id);
        setCheckedBox(idArray);

        if (responseData?.length === idArray?.length) {
          setValueAllChecked(true);
        } else {
          setValueAllChecked(false);
        }

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);
    previousPage = localStorage.getItem("previousPage");
    attributefetchApi();
  }, []);

  const handleSubmit = (event) => {
    console.log(rowsData, "885");

    let data = rowsData.filter(function (rowData) {
      return rowData.name != "";
    });
    console.log(data, "410datacome"); //

    let newdata = data.forEach((obj) => {
      obj.values = obj.values.replace(/'/g, "\\'");
    });

    console.log(newdata, "410datacome");
    const jsonobj = {};
    jsonobj.attributexml = data;

    let jsonstring = JSON.stringify(jsonobj);

    setLoading(true);

    axios
      .post(
        `${config.attributesBaseUrl}/attributes/upsert`,
        {
          loginuserid: loginUserId,
          attributesxml: jsonstring,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
          // window.history.back();
          // window.location.reload();
          attributefetchApi();
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError("Name" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }

        setLoading(false);
        // window.location.reload();
      })
      .catch((error) => {
        setLoading(false);
      });

 
  };

  // const handleSwitchOnOff = (index, id, check) => {
  //   console.log(index, id, check, "chekd");
  // };

  const handleDateFilterConfirm = () => {
    setShowDateFilterModal(false);
    handleAllSwitchOnOff(valueAllChecked);
  };

  const handleDateFilterCancel = () => {
    setShowDateFilterModal(false);
    setValueAllChecked(!valueAllChecked);
  };

  const handleAllSwitchOnOff = (checked) => {
    // const { checked } = e.target;
    console.log(checked, "checkedBy Allcategory");

    if (checked == true) {
      let finalArray = [];
      rowsData.map((el) => finalArray.push(el?.id));
      setCheckedBox(finalArray);

      const updatedData = rowsData.map((el) => {
        return {
          ...el,
          IsShowEcommerce: 1,
        };
      });
      setRowsData(updatedData);
      checkFunction(finalArray);
    } else {
      setCheckedBox([]);
      const updatedData = rowsData.map((el) => {
        return {
          ...el,
          IsShowEcommerce: 0,
        };
      });
      setRowsData(updatedData);
      checkFunction([]);
    }
  };

  const handelShowPopup = (checked) => {
    console.log(checked, "checked");
    setValueAllChecked(checked);
    setShowDateFilterModal(true);
  };

  const checkFunction = (checkedAttributes) => {
    let attributesList = {
      attributesList: checkedAttributes.join(","),
      LoginUserId: loginUserId,
    };

    console.log(attributesList, "attributesList");

    axios
      .post(
        `${config.attributesBaseUrl}/attributes/assignecommercemenu`,
        attributesList,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          // toastSuccess(SUCCESS_MESSAGE)
          console.log("SetDone");
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          // toastError(ERROR_EXISTS);
        } else {
          // toastError(ERROR_MESSAGE);
        }
      });
  };

  const handleSubmitRow = (data) => {
    console.log(data, "attributesList");
    // return;
    let singleAttributeUpsert = {
      attributeId: data.id,
      attributeName: data.name,
      IsShowEcommerce: data.IsShowEcommerce,
      attributeValue: data.values.replace(/'/g, "\\'"),
      LoginUserId: loginUserId,
    };
    setLoading(true);
    axios
      .post(
        `${config.attributesBaseUrl}/attributes/singleattributeupsert`,
        singleAttributeUpsert,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(res.data.ResponseMessage)
          // console.log("SetDone");
          attributefetchApi();
          setLoading(false);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(res.data.ResponseMessage);
          setLoading(false);
        } else {
          toastError(res.data.ResponseMessage);
          setLoading(false);
        }
      }).catch((error) => {
        console.log(error)
        setLoading(false);
      });
  };

  const handleSwitchOnOff = (index, id, check) => {
    // e. row
    console.log(check, id, "checkedBy Allcategory");

    if (check === true) {
      console.log(check, id, "checkedBy Allcategory");
      const FilterData = [...checkedBox, id];
      setCheckedBox(FilterData);

      const updatedData = rowsData.map((el) => {
        if (el.id === id) {
          return {
            ...el,
            IsShowEcommerce: 1,
          };
        } else {
          return el;
        }
      });
      setRowsData(updatedData);

      updatedData?.length === FilterData?.length
        ? setValueAllChecked(true)
        : setValueAllChecked(false);

      checkFunction(FilterData);
    } else {
      const FilterData = checkedBox.filter((item) => item !== id);
      setCheckedBox(FilterData);

      const updatedData = rowsData.map((el) => {
        if (el.id === id) {
          return {
            ...el,
            IsShowEcommerce: 0,
          };
        } else {
          return el;
        }
      });
      setRowsData(updatedData);
      checkFunction(FilterData);

      updatedData?.length === FilterData?.length
        ? setValueAllChecked(true)
        : setValueAllChecked(false);
    }
  };

  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="container-fluid">
          {/* Page Header */}
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h5 className="page-title">Inventory: Attributes</h5> */}
              <ul className="breadcrumb" style={{ marginLeft: "12px" }}>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">Manage Attributes</li>
              </ul>
            </div>
          </div>

          <div className="card mb-10">
            {/* <div className="card-header">
              <h4 className="card-title mb-0">Manage Attributes</h4>
            </div> */}
            <div className="card-body">
              <form className="mb-7">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th width="12%" className="p-regular">
                          {" "}
                          <input
                            class="form-check-input mr-1"
                            onChange={(event) =>
                              handelShowPopup(event.target.checked)
                            }
                            type="checkbox"
                            role="switch"
                            checked={valueAllChecked}
                          />{" "}
                          <label> Show On Menu</label>
                        </th>
                        <th width="20%" className="p-regular">
                          Name
                        </th>
                        <th width="63%" className="p-regular">
                          Values
                        </th>
                        {/* <th width="63%" className="p-regular">
                          Save
                        </th>
                        {checkUserPermission(PERMISSION_DELETE) ? (
                          <th width="5%" className="p-regular">
                            Delete
                          </th>
                        ) : (
                          ""
                        )} */}
                      </tr>
                    </thead>
                    <tbody>
                      <AttributeTableRows
                        rowsData={rowsData}
                        deleteTableRows={deleteTableRows}
                        handleChange={handleChangeTableRow}
                        handleChecked={handleSwitchOnOff}
                        handleSubmitRow={handleSubmitRow}
                      />
                    </tbody>
                  </table>
                </div>
                <div className="float-buttons">
                  {checkUserPermission(PERMISSION_ADD_EDIT) ? (
                      <button
                        type="button"
                        className="btn btn-secondary btn-sm pull-left"
                        onClick={addTableRows}
                      >
                        <i className="fa fa-plus fa-sm" /> Add Attribute
                      </button>
                  ) : (
                    ""
                  )}

                  {/* {checkUserPermission(PERMISSION_ADD_EDIT) ? (
                  <div className="float-buttons">
                    <button
                      type="button"
                      className="btn btn-sm btn-primary pull-right mt-3"
                      onClick={(e) => handleSubmit(e)}
                      >
                      Save
                    </button>
                    </div>
                    ) : (
                      ""
                      )} */}
                  {/* <div 
                  // className="float-buttons_save"
                  > */}
                    <button
                      type="button"
                      className="btn btn-sm btn-secondary pull-left"
                      onClick={(e) => navigate(-1)}
                    >
                      Back
                    </button>
                  {/* </div> */}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* attribute check all */}
      <div
        className={`modal ${showDateFilterModal ? "d-block" : ""} `}
        style={{ background: "rgba(0,0,0, 0.4)" }}
        tabIndex="-1"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ justifyContent: "center" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="card-title">Confirmation</h5>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => handleDateFilterCancel()}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <h6 className="col-form-label p-lg-medium">
                    Do you want to set at All ?
                  </h6>
                </div>
              </div>
            </div>

            <div className="modal-footer justify-content-center">
              {/* {checkUserPermission(PERMISSION_DELETE) ? ( */}

              <button
                type="button"
                className="btn btn-primary"
                onClick={() => handleDateFilterConfirm()}
              >
                yes
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleDateFilterCancel}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Attributes;
